import { render, staticRenderFns } from "./ViewAlbum.vue?vue&type=template&id=596179af&scoped=true"
import script from "./ViewAlbum.vue?vue&type=script&lang=js"
export * from "./ViewAlbum.vue?vue&type=script&lang=js"
import style0 from "./ViewAlbum.vue?vue&type=style&index=0&id=596179af&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596179af",
  null
  
)

export default component.exports